<template>
<div>
  <div class="wistia_embed wistia_async_on2jw345ih">
    &nbsp;
  </div>

  <div
    id="captivate-choices"
    class="tbk-vid-embed"
  >
    <a
      id="captivate-biking"
      class="embedded_video"
      href="#wistia_3fnhwjh0m6?videoFoam=true"
    >
      &nbsp;
    </a>
    <br>

    <a
      id="captivate-blind-beggar"
      class="embedded_video"
      href="#wistia_l5x89jsqox?videoFoam=true"
    >
      &nbsp;
    </a>
    <br>

    <a
      id="captivate-ikaria"
      class="embedded_video"
      href="#wistia_g6d45y237e?videoFoam=true"
    >
      &nbsp;
    </a>
    <br>

    <a
      id="captivate-continue"
      class="embedded_video"
      href="#wistia_qjnf8wer28?videoFoam=true"
    >
      &nbsp;
    </a>
    <br>
  </div>
</div>
</template>

<script>
import TbkVideoMixin from './TbkVideoMixin'

export default {
  mixins: [TbkVideoMixin],

  mounted() {
    this.tbk.loadCrossTime('on2', 61, this.showSelect)
    this.tbk.loadCrossTime('3fn', 77, this.showSelect)
    this.tbk.loadCrossTime('l5x', 65, this.showSelect)
    this.tbk.loadCrossTime('g6d', 163, this.showSelect)

    if (this.tbk.isMobile()) {
      _wq.push({
        '3fn': this.tbk.autoPlay,
        l5x: this.tbk.autoPlay,
        g6d: this.tbk.autoPlay
      })
    }
  },

  methods: {
    showSelect() {
      $('.tbk-vid-embed').show()
      this.tbk.hideMobileControls()
    }
  }
}
</script>

<style scoped lang="sass">
#captivate-biking
  position: absolute
  top: calc(100% * (134 / 360))
  left: calc(100% * (40 / 640))
  width: calc(100% * (160 / 640))
  height: calc(100% * (91 / 360))
#captivate-choices
  a
    text-decoration: none
#captivate-blind-beggar
  position: absolute
  top: calc(100% * (134 / 360))
  left: calc(100% * (239 / 640))
  width: calc(100% * (160 / 640))
  height: calc(100% * (91 / 360))
#captivate-ikaria
  position: absolute
  top: calc(100% * (134 / 360))
  left: calc(100% * (440 / 640))
  width: calc(100% * (160 / 640))
  height: calc(100% * (91 / 360))
#captivate-continue
  position: absolute
  top: calc(100% * (267 / 360))
  left: calc(100% * (228 / 640))
  width: calc(100% * (185 / 640))
  height: calc(100% * (28 / 360))
</style>
